import { render, staticRenderFns } from "./transaction-create.vue?vue&type=template&id=99a3df16&scoped=true"
import script from "./transaction-create.vue?vue&type=script&setup=true&lang=js"
export * from "./transaction-create.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a3df16",
  null
  
)

export default component.exports